<template>
  <v-container class="card-con">
    <v-card max-width="480" width="100%" class="ma-auto pa-4">
      <v-card-text class="d-flex flex-column justify-center text-center">
        <div class="d-flex justify-center">
          <v-img :src="require('@/assets/world/hamochFix.png')" max-width="200px" contain></v-img>
        </div>

        <div class="my-4">
          <div class="text-h4 mb-4">
            {{ $t("string.maintenanceTitle") }}
          </div>
          <div class="text-h6 mb-4">
            {{ $t("string.maintenanceDescription") }}
          </div>
          <div class="mb-4 text-h6"
            v-if="timestampMaintenanceEnd && $moment(timestampMaintenanceEnd).isAfter($moment())"
          >
            <v-divider class="mb-4"/>
            <CountDown :endTime="timestampMaintenanceEnd" :message="$t('string.ends_in')" />
            {{ $moment(timestampMaintenanceEnd).format("DD/MM/YYYY hh:mm:ss A") }}
          </div>

          <v-btn @click="$router.go()" class="mt-6 grey--text text--darken-2" rounded>
            <v-icon class="me-1">mdi-reload</v-icon>
            {{ $t("action.refresh") }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    isMaintaining: true,
    timestampMaintenanceEnd: '',
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
  }),
  components: {
    CountDown: () =>
      import(
        /* webpackChunkName: "component-countdown" */ "@/components/CountDown.vue"
      ),
  },
  computed: mapState({
    settings: (state) => state.settings.data,
    auth: (state) => state.auth.data,
  }),
  mounted() {
    //
  },
  async created() {
    await this.readPlatform()
  },
  methods: {
    async readPlatform() {
      this.api.url =
        this.$api.servers.log +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/platform/read";
      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };
      this.api.callbackSuccess = async (resp) => {
        this.api.isLoading = false;
        this.isMaintaining = resp.value.isMaintaining
        this.timestampMaintenanceEnd = resp.value.timestampMaintenanceEnd
      };
      this.api.params = {
        key: "MAINTENANCE"
      };
      await this.$api.fetch(this.api);
    },
  },
};
</script>

<style scoped>
.card-con {
  display: flex;
  min-width: 100vw;
  height: 100vh !important;
}
</style>
